import moment from 'moment';
import mutations from './mutations';
import actions from './actions';

export default {
  namespaced: true,
  modules: {
  },
  state: {
    clients: [],
    filtered_clients: [],
    filtered_clients_count: 0,
    contracts: [],
    contracts_count: 0,
    invoices: {},
    deleted_contract: {
      data: {},
      message: '',
      status: 'loading'
    },
    copied_contract: {
      data: {},
      message: '',
      status: 'loading'
    },
    client_updated: {
      data: {},
      message: '',
      status: 'loading'
    },
    deleted_client: {
      data: {},
      message: '',
      status: 'loading'
    },
    deleted_file: {
      data: {},
      message: '',
      status: 'loading'
    },
    last_invoice: {},
    allContracts: [],
  },
  getters: {
    clients: (state) => {
      return state.clients;
    },
    filtered_clients: (state) => {
      return state.filtered_clients;
    },
    filtered_clients_count: (state) => {
      return state.filtered_clients_count;
    },
    contracts: (state) => {
      return state.contracts;
    },
    contracts_count: (state) => {
      return state.contracts_count;
    },
    deleted_contract: (state) => {
      return state.deleted_contract;
    },
    copied_contract: (state) => {
      return state.copied_contract;
    },
    client_updated: (state) => {
      return state.client_updated;
    },
    deleted_client: (state) => {
      return state.deleted_client;
    },
    deleted_file: (state) => {
      return state.deleted_file;
    },
    invoices: (state) => {
      return state.invoices;
    },
    last_invoice: (state) => {
      return state.last_invoice;
    },
    allContracts: (state) => {
      return state.allContracts;
    },
    invoicesByProjectByYearweek: (state) => {
      const revenue = {};
      for (const invoiceId in state.invoices) {
        const invoice = state.invoices[invoiceId];
        const overdue = invoice.paid_sum == 0 && new Date(invoice.due_date) < new Date();
        if (invoice.project_id) {
          if (!revenue[invoice.project_id]) revenue[invoice.project_id] = {};

          var yearweek;
          if (invoice.paid_sum) yearweek = moment(new Date(invoice.payment_date)).format('GGGGWW');
          else if (!overdue) yearweek = moment(new Date(invoice.due_date)).format('GGGGWW');
          else yearweek = moment().format('GGGGWW');

          if (!revenue[invoice.project_id][yearweek]) {
            revenue[invoice.project_id][yearweek] = {
              received: 0,
              planned: 0,
              overdue: 0
            }; 
          }
                    
          if (invoice.paid_sum) revenue[invoice.project_id][yearweek].received += invoice.paid_sum;
          else if (!overdue) revenue[invoice.project_id][yearweek].planned += invoice.sum;
          else revenue[invoice.project_id][yearweek].overdue += invoice.sum;
        }
      }
      return revenue;
    },
    invoicesByYearweek: (state) => {
      const invoices = {};
      for (const invoiceId in state.invoices) {
        const invoice = state.invoices[invoiceId];
        const overdue = invoice.paid_sum == 0 && new Date(invoice.due_date) < new Date();
        var yearweek;

        if (invoice.paid_sum) yearweek = moment(new Date(invoice.payment_date)).format('GGGGWW');
        else if (!overdue) yearweek = moment(new Date(invoice.due_date)).format('GGGGWW');
        else yearweek = moment().format('GGGGWW');

        if (!invoices[yearweek]) {
          invoices[yearweek] = {
            received: 0,
            planned: 0,
            overdue: 0
          }; 
        }
                
        if (invoice.paid_sum) invoices[yearweek].received += invoice.paid_sum;
        else if (!overdue) invoices[yearweek].planned += invoice.sum;
        else invoices[yearweek].overdue += invoice.sum;
      }
      return invoices;
    },
    projectRevenue: (state) => {
      const revenue = {};
      for (const invoiceId in state.invoices) {
        if (state.invoices[invoiceId].project_id) {
          if (!revenue[state.invoices[invoiceId].project_id]) revenue[state.invoices[invoiceId].project_id] = 0;
          revenue[state.invoices[invoiceId].project_id] += state.invoices[invoiceId].paid_sum;
        }
      }
      return revenue;
    },
    invoicesByDueDate: (state) => {
      const invoices = Object.values(state.invoices);
      invoices.sort((a, b) => {
        return new Date(a.due_date) < new Date(b.due_date);
      });
      return invoices;
    },
    overdueInvoicesByProject: (state) => { // for drawing graphs
      const invoices = {};
      for (const invoiceId in state.invoices) {
        const invoice = state.invoices[invoiceId];
        if (invoice.paid_sum == 0 && new Date() > new Date(invoice.due_date)) {
          if (!invoices[invoice.project_id]) invoices[invoice.project_id] = 0;
          invoices[invoice.project_id] += invoice.sum;
        }
      }
      return invoices;
    },
  },
  mutations,
  actions
};
